import { observer } from "mobx-react-lite"
import { useEffect, useState } from "react"
import { ProfileAvatar } from "../components/ProfileAvatar"
import { StatsCard } from "../components/StatsCard"
import FCMService from "../services/FCMService"
import { rootStore } from "../StApp"
import { ProfileStore } from "../stores/ProfileStore"
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";
import Switch from "@mui/material/Switch/Switch"
import { GoogleLogin } from "react-google-login"
import { GOOGLE_CLIENT_ID } from "../models/constants"
import Logger from "../services/Logger"
import PullToRefresh from "react-simple-pull-to-refresh"


export const Dashboard = observer(() => {

    const [store] = useState(rootStore.profileStore)

    const notifEnabled = rootStore.notifManager.enabled
    const dateEnabled = rootStore.profileStore.dateEnabled
    const statusOnline = rootStore.notifManager.onlineStatus

    useEffect(() => {
        store.loadProfile()
    }, [])

    function googleAuthSuccess(resp: any){
        store.handleGoogleAuthEmail(resp)
    }

    function googleAuthFail(resp: any){
        Logger.err(resp, 'GOOGLE_AUTH_FAILED')
    }

    async function refreshProfile(){
        store.loadProfile()
    }

    return (
        <motion.div className='flex-column center-align absolute'
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
            style={{height: '100%', overflow:'scroll'}}
        >
            <PullToRefresh className='relative' onRefresh={refreshProfile} pullDownThreshold={100} maxPullDownDistance={100} >
                <div className='flex-column center-align' >
                    <ProfileAvatar sex={store.myProfileResp?.sex ? store.myProfileResp.sex : 'M'} />
                    <h3>{store.name}</h3>
                    <p>{window.location.hostname}/{rootStore.mainStore.userName}</p>
                    <h4>{store.geoLocation?.city}, {store.geoLocation?.state}, {store.geoLocation?.country}</h4>
                    <div className='flex-row center-align' >
                        <h4>Notifications</h4>
                        <Switch
                            checked={notifEnabled}
                            onChange={() => rootStore.notifManager.toggleNotification()}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    </div>
                    <div className='flex-row center-align' >
                        <h4>Dating</h4>
                        <Switch
                            checked={dateEnabled}
                            onChange={() => store.toggleDateEnabled() }
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    </div>
                    {/* <div className='flex-row' >
                        <h4>Online</h4>
                        <button style={{ backgroundColor: statusOnline ? 'green' : 'yellow' }} onClick={() => rootStore.notifManager.toggleOnlineStatus()} >ON</button>
                    </div> */}
                    <div className='flex-row container-statsboard' >
                        <StatsCard key={0} backgroundColor='green' label='Profile Visits' value={store.profileVisits} />
                        <StatsCard key={1} backgroundColor='blue' label='VIntro Plays' value={store.vIntroVisits} />
                        <StatsCard key={2} backgroundColor='purple' label='Liked You' value={store.likesGot} />
                        <StatsCard key={3} backgroundColor='red' label='Unliked You' value={store.dumpCount} />
                        <StatsCard key={4} backgroundColor='green' label='Times you were shown' value={store.shownCount} />
                        <StatsCard key={5} backgroundColor='pink' color='purple' label='Matches' value={store.matches} />
                        <StatsCard key={7} backgroundColor='yellow' color='black' label='You Swiped Left' value={store.leftSwipes} />
                        <StatsCard key={6} backgroundColor='violet' label='You swiped Right' value={store.rightSwipes} />
                    </div>
                    <div className='flex-row' style={{marginBottom: 15}}>
                        <GoogleLogin
                            clientId={GOOGLE_CLIENT_ID}
                            buttonText={store.email? 'Connected': 'Connect Google'}
                            onSuccess={googleAuthSuccess}
                            onFailure={googleAuthFail}
                        />
                        {store.email? <button className='button-styled button-delink' onClick={()=>store.delinkEmail()} >Delink</button>:null }
                    </div>
                </div>
            </PullToRefresh>
        </motion.div>
    )
})